<template>
  <div
    class="app"
    :class="{ noPadding: $route.path.indexOf('/record') > -1, inApp: $root.$data.isApp }"
  >
    <!-- :key="appkey" -->
    <router-view v-if="!$route.meta.keepAlive"></router-view>
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive" />
    </keep-alive>
    <BrowseTime />
    <BrowseTask/>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { Dialog } from 'vant';
import { reqArkChoose } from '@/api/home';
import { searchUrl } from '@/utils/tools';
import BrowseTime from './components/browseTime/index.vue';
import BrowseTask from '@/pages/collectCard/component/browseTask.vue'

export default {
  props: [],
  data() {
    return {
      currentEnv: '', // 当前项目所在环境：dev、test、pre；线上默认为空
      
    };
  },
  components: {
    BrowseTime,
    BrowseTask,
  },
  computed: {
    ...mapState(['loginControl', 'userInfo']),
  },
  watch: {
    $route() {},
  },
  async created() {
    // this.initQuickLogin();
    this.setCurrentPath();
    await this.$root.getUserInfo();
    this.getRecentYear();
    // 判断是首次进入，还是页面刷新
    const webLoadMode = sessionStorage.getItem('webLoadMode');
    if (!webLoadMode) {
      // console.log('首次被加载');
      // 在首次进入页面时我们给window.name设置一个固定值(isRefresh)
      sessionStorage.setItem('webLoadMode', 'refresh');
    } else if (webLoadMode === 'refresh') {
      // console.log('页面被刷新');
    }
  },
  mounted() {},
  methods: {
    ...mapActions(['setcurrentyear']),
    setCurrentPath() {
      ['dev', 'test', 'pre'].some((item) => {
        if (window.location.href.indexOf(item) !== -1) {
          this.currentEnv = item;
          this.$store.dispatch('saveCurrentEnv', item);
          return true;
        }
        return false;
      });
      this.checkUrl();
    }, // 根据环境设置当前json请求前缀
    checkUrl() {
      const { hostname, pathname, search } = window.location;
      if (hostname === 'localhost' || process.env.VUE_APP_ENV === 'local' || this.$root.$data.isApp || this.$root.miniprogram) return;
      const UserClient = navigator.userAgent.toLowerCase();
      const isWap = /ipad|iphone|midp|rv:1.2.3.4|ucweb|android|windows ce|windows mobile/i.test(
        UserClient,
      );
      if (!isWap && (pathname === '/ark/personalCenter/handselDetail' || pathname === '/ark/businessOrder' || pathname === '/ark/othersPay')) {
        Dialog.alert({
          message: '请用手机浏览器打开链接',
        });
        return;
      }
      const { currentEnv } = this;
      // eslint-disable-next-line max-len
      if (!isWap) {
        window.location.href = `//${
          currentEnv ? `${currentEnv}` : 'www'
        }.iqihang.com${pathname}${search}`;
      }
    }, // 判断设备地址切换
    // 查询上次选择的考季
    async getRecentYear() {
      if (!this.userInfo?.id) {
        this.setVersion();
        return;
      }

      const res = await reqArkChoose();
      if (res.code === 0 && res?.data?.data?.length) {
        const code = res.data.data[0];
        this.showVersion(code);
      }
    },
    // 未登录时根据当前路由的code 设置左上角的年份
    setVersion() {
      const code = searchUrl('code');
      const obj = {
        code: Number(code),
        examTypeId: Number(code),
      };
      this.showVersion(obj);
    },
    showVersion(code) {
      if (code.examTypeId === 1) {
        Object.assign(code, { value: '22复试', code: code.examTypeId });
      } else if (code.examTypeId === 3) {
        Object.assign(code, { value: '四六级', code: code.examTypeId });
      } else if (code.examTypeId === 4) {
        Object.assign(code, { value: '会计', code: code.examTypeId });
      } else if (code.examTypeId === 5) {
        Object.assign(code, { value: '大学生考试', code: code.examTypeId });
      } else if (code.examTypeId === 7) {
        Object.assign(code, { value: '日语', code: code.examTypeId });
      } else if (code.examTypeId === 8) {
        Object.assign(code, { value: '24考研', code: code.examTypeId });
      } else if (code.examTypeId === 9) {
        Object.assign(code, { value: '教师资格', code: code.examTypeId });
      } else if (code.examTypeId === 10) {
        Object.assign(code, { value: '25考研', code: code.examTypeId });
      } else if (code.examTypeId === 12) {
        Object.assign(code, { value: '26考研', code: code.examTypeId });
      } else {
        Object.assign(code, { value: '23复试', code: code.examTypeId });
      }
      this.setcurrentyear(code);
    },
    initQuickLogin() {
      if (window.location.pathname === '/ark/quickLogin') return;
      const that = this;
      // eslint-disable-next-line no-unused-expressions
      window.JVerificationInterface?.init({
        appkey: 'c76ec3b512d9a2551cd3c977', // 极光官网中创建应用后分配的 appkey，必填
        debugMode: true, // 设置是否开启 debug 模式。true 则会打印更多的日志信息。设置 false 则只会输出 w、e 级别的日志。
        domainName: window.location.origin,
        success: (data) => {
          console.log(data, '初始化成功--app');
          // that.getToken();
        },
      });
    },
    getToken() {
      const that = this;
      // eslint-disable-next-line no-unused-expressions
      window.JVerificationInterface?.getToken({
        operater: 'CU',
        success: (data) => {
          console.log(data, '获取token成功--app');
          const { operater } = data;
          that.$root.initOperater = operater;
          that.$root.showQuickLogin = true;
        },
        fail: (b) => {
          console.log(b, '获取token失败');
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
html,
body {
  position: relative;
  overflow: hidden;
}
.app {
  min-height: 100%;
  background: #f9f9f9;
  //background: #fefeff;
}
</style>
